document.documentElement.classList.add('js');

/* The qualifier tiles are the top of the funnel: each one drops the visitor
   into the quote form with their answer already filled in, so the form starts
   part-done. The bar keeps that one action reachable without following the
   scroll all the way back up — and gets out of the way once the form is on
   screen, where it would just be shouting over itself. */
(function(){
  var sel = document.getElementById('q-wh');
  document.querySelectorAll('.cro-tile').forEach(function(t){
    t.addEventListener('click', function(){
      if(sel) sel.value = t.dataset.where;
      var form = document.getElementById('custom');
      if(form) form.scrollIntoView({behavior:'smooth', block:'start'});
      var first = document.getElementById('q-nm');
      if(first) setTimeout(function(){ first.focus({preventScroll:true}); }, 420);
    });
  });

  var bar = document.getElementById('crobar'), quote = document.getElementById('custom');
  if(!bar) return;
  if(!('IntersectionObserver' in window)){ bar.classList.add('on'); return; }
  var past = false, formUp = false;
  function paint(){ bar.classList.toggle('on', past && !formUp); }
  var hero = document.querySelector('.hero');
  if(hero){
    new IntersectionObserver(function(es){
      past = !es[0].isIntersecting; paint();
    }, {threshold:0}).observe(hero);
  } else { past = true; }
  if(quote){
    new IntersectionObserver(function(es){
      formUp = es[0].isIntersecting; paint();
    }, {threshold:0.15}).observe(quote);
  }
  paint();
})();

/* Shop preview behaviour: option chips, quantity and the gallery. Nothing here
   talks to a cart — on Shopify the theme's own product form does that. */
(function(){
  function group(el){ return el.parentElement.querySelectorAll('[aria-pressed]'); }
  var fig = document.getElementById('shprice'), was = document.getElementById('shwas');
  document.querySelectorAll('.sh-chip').forEach(function(b){
    b.addEventListener('click', function(){
      group(b).forEach(function(o){ o.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      /* the chips carry the store's own price for that size */
      if(fig && b.dataset.price){
        fig.innerHTML = b.dataset.price;
        if(was){ was.innerHTML = b.dataset.was || ''; was.hidden = !b.dataset.was; }
      }
      /* on Shopify each chip is a real variant: point the basket at it */
      var form = document.querySelector('form[data-buy]');
      if(form && b.dataset.variant){
        form.querySelector('[name="id"]').value = b.dataset.variant;
        var go = form.querySelector('[type="submit"]'), ok = b.dataset.available === 'true';
        go.disabled = !ok;
        go.textContent = ok ? 'Add to basket' : 'Out of stock';
      }
    });
  });
  var qty = document.getElementById('shqty');
  if(qty){
    document.querySelectorAll('.sh-qty button').forEach(function(b){
      b.addEventListener('click', function(){
        var n = parseInt(qty.value,10) || 1;
        qty.value = Math.min(99, Math.max(1, n + parseInt(b.dataset.step,10)));
      });
    });
  }
  var sols = document.querySelectorAll('.sh-sol');
  if(sols.length){
    sols.forEach(function(b){
      b.addEventListener('click', function(){
        sols.forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        var want = b.dataset.sol;
        document.querySelectorAll('.sh-grid .sh-card').forEach(function(c){
          c.hidden = !!want && c.dataset.solution !== want;
        });
      });
    });
  }
  var buy = document.querySelector('form[data-buy]');
  if(buy && buy.getAttribute('action') === 'cart.html'){
    buy.addEventListener('submit', function(e){ e.preventDefault(); });
  }
  var quote = document.getElementById('shquote');
  if(quote){
    quote.addEventListener('submit', function(e){
      quote.querySelectorAll('.sh-err').forEach(function(n){ n.remove(); });
      var bad = [].slice.call(quote.querySelectorAll('[required]'))
                  .filter(function(f){ return !f.value.trim(); });
      if(bad.length){
        bad.forEach(function(f){
          var m = document.createElement('div');
          m.className = 'sh-err';
          m.textContent = 'We need this one';
          f.parentNode.appendChild(m);
        });
        e.preventDefault();
        bad[0].focus();
        return;
      }
      // on the store this posts to Shopify's contact form, which emails the
      // shop; the prototype on its own has nowhere to send it
      if(quote.getAttribute('action')){
        var b = quote.querySelector('[type=submit]');
        if(b){ b.disabled = true; b.textContent = 'Sending…'; }
        return;
      }
      e.preventDefault();
      document.getElementById('shquotenote').textContent =
        'Prototype only — nothing was sent.';
    });
  }
  var main = document.getElementById('shmain');
  if(main){
    document.querySelectorAll('.sh-thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        document.querySelectorAll('.sh-thumbs button').forEach(function(o){
          o.setAttribute('aria-current','false');
        });
        b.setAttribute('aria-current','true');
        main.src = b.dataset.src;
        main.alt = b.querySelector('img').alt;
      });
    });
  }
})();

/* the phone menu: open and close, and close again on a link, a tap outside,
   Escape, or the window growing past the breakpoint */
(function(){
  var nav = document.querySelector('.lf-nav');
  var btn = nav && nav.querySelector('.lf-burger');
  if(!btn) return;
  function set(open){
    nav.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  btn.addEventListener('click', function(){ set(!nav.classList.contains('open')); });
  [].forEach.call(nav.querySelectorAll('.lf-br a'), function(a){
    a.addEventListener('click', function(){ set(false); });
  });
  document.addEventListener('click', function(e){
    if(nav.classList.contains('open') && !nav.contains(e.target)) set(false);
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && nav.classList.contains('open')){ set(false); btn.focus(); }
  });
  var wide = window.matchMedia('(min-width: 1181px)');
  var shut = function(e){ if(e.matches) set(false); };
  wide.addEventListener ? wide.addEventListener('change', shut) : wide.addListener(shut);
})();

/* Self-contained so the block behaves the same on all four concepts, including
   the one with no reveal observer of its own. Written to survive the Shopify
   build, which strips scripts out of the body and concatenates them into one
   asset file — so no document.currentScript, and no assumption about when it
   runs relative to the markup. */
(function(){
  document.documentElement.classList.add('ch-js');
  function start(){
    var els = [].slice.call(document.querySelectorAll('.ch'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.15});
    els.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


(function(){
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $  = s => document.querySelector(s);
  const $$ = s => [...document.querySelectorAll(s)];

  /* ---------- reveal targets ---------- */
  $$('.paths > div, .venues > div, .rev3 > div, .adv > div, .faq details, .cms > div, .chips span, .quoteblk > .wrap > *, #contact .wrap > *')
    .forEach(el => { if(!el.classList.contains('rv')) el.classList.add('rv'); });

  /* ---------- scroll progress + sticky nav ---------- */
  const prog = document.createElement('div'); prog.className = 'prog'; document.body.appendChild(prog);
  const nav = $('#nav');
  function onScroll(){
    const h = document.documentElement.scrollHeight - innerHeight;
    prog.style.width = (h > 0 ? (scrollY / h) * 100 : 0) + '%';
    if(nav) nav.classList.toggle('stuck', scrollY > 30);
  }
  addEventListener('scroll', onScroll, {passive:true});
  document.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* ---------- reveals + marker sweep ---------- */
  if('IntersectionObserver' in window && !REDUCED){
    const io = new IntersectionObserver(es => es.forEach(e => {
      if(!e.isIntersecting) return;
      const el = e.target;
      const sibs = el.parentElement ? [...el.parentElement.children].filter(c=>c.classList.contains('rv')) : [];
      setTimeout(() => el.classList.add('in'), Math.min(Math.max(sibs.indexOf(el),0), 5) * 70);
      io.unobserve(el);
    }), {threshold:.18, rootMargin:'0px 0px -8% 0px'});
    $$('.rv, .draw').forEach(el => io.observe(el));

    const ioM = new IntersectionObserver(es => es.forEach(e => {
      if(e.isIntersecting){ e.target.classList.add('lit'); ioM.unobserve(e.target); }
    }), {threshold:.6, rootMargin:'0px 0px -6% 0px'});
    $$('.mk').forEach(m => ioM.observe(m));
  } else {
    $$('.rv, .draw').forEach(el => el.classList.add('in'));
    $$('.mk').forEach(m => m.classList.add('lit'));
  }

  /* ---------- hero typing ---------- */
  function type(el, text, speed){
    return new Promise(res => {
      if(REDUCED){ el.textContent = text; return res(); }
      let i = 0;
      (function step(){
        el.textContent = text.slice(0, i);
        if(i++ <= text.length) setTimeout(step, speed);
        else res();
      })();
    });
  }
  const l1=$('.l1'), l2=$('.l2'), c1=$('.c1'), c2=$('.c2'), band=$('.hero .inv'), q=$('.hero .q');
  (async function run(){
    if(REDUCED || !l1) return;
    const t1 = l1.textContent, t2 = l2.textContent;
    l1.textContent=''; l2.textContent='';
    band.classList.add('closed'); q.classList.add('hid');
    c1.style.display='inline-block';
    await new Promise(r=>setTimeout(r,260));
    await type(l1, t1, 40);
    c1.style.display='none';
    band.classList.remove('closed');
    await new Promise(r=>setTimeout(r,330));
    c2.style.display='inline-block';
    await type(l2, t2, 38);
    c2.style.display='none';
    q.classList.remove('hid');
  })();

  /* ---------- enquiry form (runs regardless of motion preference) ---------- */
  const form = $('#enquiry');
  if(form){
    form.addEventListener('submit', function(e){
      $$('.err').forEach(n => n.remove());
      const bad = $$('#enquiry [required]').filter(f => !f.value.trim());
      if(bad.length){
        e.preventDefault();
        bad.forEach(f => {
          const m = document.createElement('div');
          m.className='err lbl';
          m.style.cssText='color:var(--red-ink);margin-top:7px';
          m.textContent='Required';
          f.parentNode.appendChild(m);
        });
        bad[0].focus();
        return;
      }
      // on the store the form posts to Shopify's contact form, which emails
      // the shop; the prototype on its own has nowhere to send it
      if(form.getAttribute('action')){
        const b = form.querySelector('[type=submit]');
        if(b){ b.disabled = true; b.textContent = 'Sending…'; }
        return;
      }
      e.preventDefault();
      const n = $('.formnote'); if(n) n.textContent='Prototype only — nothing was sent.';
    });
  }

  if(REDUCED) return;

  /* ---------- scroll-driven marquee + rotating badge ---------- */
  const track=$('.tick-track'), badge=$('.spin');
  let lastY=scrollY, vel=0, offset=0;
  function frame(){
    offset -= 0.55 + Math.min(Math.abs(vel)*0.10, 7);
    if(track){
      const half = track.scrollWidth/2;
      if(half>0 && -offset>=half) offset += half;
      track.style.transform = `translateX(${offset}px)`;
    }
    vel *= 0.9;
    requestAnimationFrame(frame);
  }
  addEventListener('scroll', ()=>{
    vel = scrollY-lastY; lastY = scrollY;
    if(badge) badge.style.transform = `rotate(${scrollY*0.06}deg)`;
  }, {passive:true});
  if(track){ track.style.animation='none'; track.style.willChange='transform'; }
  frame();
})();
